import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import SubscriptionFactory from "../../Entity/Factories/SubscriptionFactory";

export default function* subscriptionList(action: ActionInterface): any {
  try {
    const res = yield call(Http.get, "subscriptions");

    // Iterate through each raw email account data and convert them to objects.
    const subscriptions = res.data.subscriptions.map(subscription => {
      return SubscriptionFactory.create(subscription);
    });

    yield put({
      type: Constants.GLOBAL_SUBSCRIPTION_LIST_SUCCESS,
      payload: {
        subscriptions: subscriptions
      }
    });

  } catch (err) {
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchSubscriptionList() {
  yield takeEvery(Constants.GLOBAL_SUBSCRIPTION_LIST, subscriptionList);
}
